import { h, AnyComponent, RenderableProps } from 'preact'

function ClientComponent<P> (C: AnyComponent<P>, name: string, props: RenderableProps<P>, wrapper: keyof JSX.IntrinsicElements = 'div') {
  const Wrapper = wrapper
  return (
    <Wrapper data-preact={name} data-props={JSON.stringify(props)}>
      <C {...props} />
    </Wrapper>
  )
}

export default ClientComponent
